<template>
    <mm-select :options="options"
    v-bind="$attrs" :value="value" v-on="$listeners" />
</template>

<script>
export default {
	data(){
		const options = ['u', 'd1', 'd2', 'dd2', 'd3', 'v1', 'v2', 'vv2', 'v3', 'c', 'o'].map(v => {
			return { value: v, label: 'Level ' + v.toUpperCase() };
		});
		return{
			options,
		}
	},
	props:['value'],
}
</script>

